export default __webpack_public_path__ + "static/media/i047vp.06d90c87.webp";